import React from "react";
import "../styles/chat.css";

import { useAuthStore } from "../store/authStore";
import { getLeadsByClient, getLeadsByProperty, getDailyLeadsTrend, getLeadScoreDistribution, getWeeklyLeadsTrend, getMonthlyLeadsTrend } from "../hooks/useDashboard.js";

import { useDashboardSummary } from "../queries/auth/useDashboard.js";

const LeadsTrendChart = React.lazy(() =>
  import("../components/dashboard/LeadsTrendChart")
);

const DashboardCard = React.lazy(() =>
  import("../components/dashboard/DashboardCard")
);

const LeadScoreChart = React.lazy(() =>
  import("../components/dashboard/LeadScoreChart")
);

const PropertyLeadsChart = React.lazy(() =>
  import("../components/dashboard/PropertyLeadsChart")
);

export default function Dashboard() {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  const { data: dashboardSummary } = useDashboardSummary();
  const stats = dashboardSummary?.data?.summary || {};
  let leadsByClient = [];
  if(isAdmin) {
    leadsByClient = getLeadsByClient(dashboardSummary?.data?.leads_by_client || []);
  }
  const leadsByProperty = getLeadsByProperty(dashboardSummary?.data?.leads_by_property || []);
  const leadScoreData = getLeadScoreDistribution(dashboardSummary?.data?.lead_score_distribution || []);
  const weeklyTrend = getWeeklyLeadsTrend(dashboardSummary?.data?.lead_trend?.weekly || []);
  const monthlyTrend = getMonthlyLeadsTrend(dashboardSummary?.data?.lead_trend?.monthly || []);
  const DailyTrend = getDailyLeadsTrend(dashboardSummary?.data?.lead_trend?.daily || []);


  return (
    <section className="dashboard-container">
      <div>
        <h1 className="dashboard-title">
          {isAdmin
            ? "LeadIQ Admin Dashboard"
            : "LeadIQ Agent Dashboard"}
        </h1>

        {/* KPI Cards */}
        <div className="dashboard-grid grid-cards mb-4">

          {isAdmin && (
            <DashboardCard
              title="Total Clients"
              value={stats.total_clients}
              // trend="up"
              // trendValue="12"
            />
          )}

          <DashboardCard
            title="Total Properties"
            value={stats.total_properties}
            // trend="up"
            // trendValue="8"
          />

          <DashboardCard
            title="Total Leads"
            value={stats.total_leads}
              // trend="up"
              // trendValue="15"
          />

          <DashboardCard
            title="Hot Leads"
            value={stats.hot_leads}
            // trend="up"
            // trendValue="20"
          />

          <DashboardCard
            title="Warm Leads"
            value={stats.warm_leads}
            // trend="down"
            // trendValue="5"
          />

          <DashboardCard
            title="Cold Leads"
            value={stats.cold_leads}
            // trend="down"
            // trendValue="10"
          />
        </div>

        {/* Charts */}
        <div className="dashboard-charts mb-4">

          <div className="grid-auto-fit my-3">

            {/* Admin Only */}
            {isAdmin && (
              <div className="chart-box">
                <PropertyLeadsChart
                  data={leadsByClient}
                  title="Leads by Client"
                />
              </div>
            )}

            <div className="chart-box">
              <PropertyLeadsChart
                data={leadsByProperty}
                title="Leads by Property"
              />
            </div>
          </div>

          <div className="grid-auto-fit mt-4">
            <div className="chart-box">
              <LeadScoreChart data={leadScoreData} />
            </div>

            <div className="chart-box">
              <LeadsTrendChart
                weeklyData={weeklyTrend}
                monthlyData={monthlyTrend}
                dailyData={DailyTrend}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}